import template from './template.html'

angular.module('contabilidad.reportenominasmovimientos')
  .component('contabilidadReportenominasmovimientos', {
    controller: ContabilidadReportenominasmovimientosComponent,
    template,
    bindings: {
      busqueda: '<',
    },
  })

function ContabilidadReportenominasmovimientosComponent ($q, ContabilidadReportenominasmovimientos, ContabilidadReportenominasmovimientosEmpresas, ContabilidadReportenominasmovimientosConceptos, CatalogoRegimenesFiscales, $location, $moment) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.buscar = buscar

  $ctrl.data = null
  $ctrl.procesando = false
  $ctrl.filtros_fecha = [
    {value: '1', descripcion: 'Fecha de Nómina'},
    {value: '2', descripcion: 'Fecha de Pago'},
  ]
  $ctrl.reportes = [
    {value: '1', descripcion: 'General'},
    {value: '2', descripcion: 'Detallado por colaborador'},
    {value: '3', descripcion: 'Tabulado de Percepciones por cliente'},
    {value: '4', descripcion: 'Detallado de nóminas por colaborador'},
  ]

  function $onInit () {
    $ctrl.busqueda = {
      empresa_id: $ctrl.busqueda.empresa_id || undefined,
      fechaInicial: $ctrl.busqueda.fechaInicial || $moment().subtract(1, 'months').toDate(),
      fechaFinal: $ctrl.busqueda.fechaFinal || new Date(),
      reporte: $ctrl.busqueda.reporte || undefined,
      filtro_fecha: $ctrl.busqueda.filtro_fecha || undefined,
      conceptos: $ctrl.busqueda.conceptos || undefined,
      clientes: $ctrl.busqueda.clientes || undefined,
      regimenes_fiscales: $ctrl.busqueda.regimenes_fiscales || 0,
    }

    $ctrl.promise = $q.all([
      CatalogoRegimenesFiscales.get()
        .then(function (response) {
          $ctrl.regimenesFiscales = response.data
          $ctrl.regimenesFiscales.unshift({id: 0, descripcion: 'Todos'})
        }),
      ContabilidadReportenominasmovimientosEmpresas.get()
        .then(function (response) {
          $ctrl.empresas = response.data
        }),
    ])
  }

  function buscar () {
    if ($ctrl.procesando) return

    $ctrl.procesando = true
    $ctrl.data = null

    $ctrl.form.$setPristine()

    var busqueda = {
      empresa_id: $ctrl.busqueda.empresa_id,
      fechaInicial: $ctrl.busqueda.fechaInicial.toYMD(),
      fechaFinal: $ctrl.busqueda.fechaFinal.toYMD(),
      reporte: $ctrl.busqueda.reporte,
      filtro_fecha: $ctrl.busqueda.filtro_fecha,
      conceptos: $ctrl.busqueda.conceptos ? ($ctrl.busqueda.conceptos.length ? $ctrl.busqueda.conceptos : undefined) : undefined,
      clientes: $ctrl.busqueda.clientes ? ($ctrl.busqueda.clientes.length ? $ctrl.busqueda.clientes : undefined) : undefined,
      regimenes_fiscales: $ctrl.busqueda.regimenes_fiscales,
    }

    $location.search(busqueda)

    ContabilidadReportenominasmovimientos.get(busqueda)
      .then(function (response) {
        $ctrl.data = response.data
      })
      .finally(function () {
        $ctrl.procesando = false
      })
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/reportenominasmovimientos/components/component.js